import {call, put, takeLatest} from "redux-saga/effects";

import {PatientsAPI} from "../../../api/patientsAPI";
import {
  EDIT_MEDICATION_REQUEST,
  EDIT_MEDICATION_SUCCESS,
  EDIT_MEDICATION_ERROR,
  SET_TOAST
} from "../../actions";
import {IMedication, ToastType} from "../../../utils/interfaces";
import {endOfToday, endOfYesterday, parse} from "date-fns";
import {getMedicationForCreation} from "../../../utils/dataHandlers";

function* workerEditMedication({
  type,
  payload: {medicationId, patientId, updatedMedication, existingMedication},
}: {
  type: string;
  payload: {
    medicationId: any;
    patientId: any;
    updatedMedication: IMedication;
    existingMedication?: IMedication;
  };
}): Generator<any> {
  try {
    if (existingMedication) {
      yield call(PatientsAPI.deleteMedication, patientId, medicationId);
      yield call(PatientsAPI.addMedication, getMedicationForCreation({...existingMedication, endDate: endOfYesterday(), startDate: parse(existingMedication.startDate, 'yyyy-MM-dd', new Date())}, existingMedication.times), patientId);
      yield call(PatientsAPI.addMedication, getMedicationForCreation({...updatedMedication, startDate: endOfToday(), endDate: parse(updatedMedication.endDate, 'yyyy-MM-dd', new Date())}, updatedMedication.times), patientId);

      yield put({
        type: SET_TOAST,
        payload: {
          open: true,
          message: "Medication was edited successfully",
          type: ToastType.SUCCESS,
        }
      });
    } else {
      const data: any = yield call(PatientsAPI.editMedication, patientId, medicationId, updatedMedication);

      yield put({
        type: EDIT_MEDICATION_SUCCESS,
        payload: {defaultMedications: data}
      });
      yield put({
        type: SET_TOAST,
        payload: {
          open: true,
          message: "Medication was edited successfully",
          type: ToastType.SUCCESS,
        }
      });
    }
  } catch (error: any) {
    yield put({
      type: EDIT_MEDICATION_ERROR,
      payload: {code: error.response.status, message: error.message}
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Something went wrong",
        type: ToastType.ERROR,
      }
    });
  }
}

export function* watcherEditMedication() {
  yield takeLatest(EDIT_MEDICATION_REQUEST, workerEditMedication);
}
